<!-- <form #f="ngForm" autocomplete="off" id="f"> -->
  <div class="ui-g ui-fluid">
    <div class="ui-g-12 ui-lg-12">
      <div class="card card-w-title">

        <!-- HEADER -->
        <form #f="ngForm" id="f">
          <div *ngIf="acao === 'formulario'">

            <div class="row no-padding">
              <app-cabecalho-de-impressao
                #appCabecalhoDeImpressao
                [carregarOnLoad]="false"
                [nomeRelatorio]="nome"
                [acao]="acao">
              </app-cabecalho-de-impressao>
            </div>

            <!-- CONTEUDO ESPECIFICO DE CADA RELATORIO -->
            <div class="container-relatorio-base">
              <ng-container
                [ngTemplateOutlet]="relatorioBase">
              </ng-container>
            </div>
            <!-- CONTEUDO ESPECIFICO DE CADA RELATORIO -->

            <div class="container-botao-carregar" align="center">
              <p-button label="Carregar"
                        [disabled]="false"
                        (click)="carregarRelatorio()">
              </p-button>
            </div>
            
          </div>
        </form>
        <!-- /HEADER -->

        <!-- BODY -->
        <div class="ui-g form-group" >
          <div class="ui-g-12 no-padding" [hidden]="acao !== 'relatorio'">
            <ng-container *ngIf="controller">
              <app-relatorio
                #appRelatorio
                [nomeRelatorio]="nome"
                [controller]="controller">
              </app-relatorio>
            </ng-container>
          </div>
        </div>
        <!-- /BODY -->

      </div>
    </div>
  </div>
<!-- </form> -->
